import { ReactElement } from 'react';

import { Header, NavTabs, Panel } from '@dreryk/react-components';

import { systemActivityTranslationKeys } from './translations';
import { SystemActivityNavTabsParams } from './SystemActivityPanel.types';
import { ConfidentialResourceAccessRequestsTable } from './confidentialResourceDataAccess/ConfidentialResourceAccessRequestsTable';

export const SystemActivityPanel = (): ReactElement => {
   return (
      <Panel testId={'systemActivity'} direction='column'>
         <Header testId={'systemActivity'}>{systemActivityTranslationKeys.systemActivity}</Header>
         <NavTabs<SystemActivityNavTabsParams> testId={'systemActivity'}>
            <NavTabs.Tab
               testId={SystemActivityNavTabsParams.MEDICAL_DATA_ACCESS}
               param={SystemActivityNavTabsParams.MEDICAL_DATA_ACCESS}
               label={systemActivityTranslationKeys.medicalDataAccess}
            >
               <ConfidentialResourceAccessRequestsTable />
            </NavTabs.Tab>
         </NavTabs>
      </Panel>
   );
};
